import React from "react";
import styles from "./BannerMedio.module.scss";
import { IMedio } from "@/components/templates/search/interfaces/IEstructuraPrincipal";


export const BannerMedio = ({ cardWide, medio }: IMedio) => {
	if (medio === undefined || !medio.activo) return null
	const { url, imagenes, alt } = medio ?? {}
	const { srcDefault, srcHorizontal } = imagenes ?? {}

	return (

		<a href={url} target='_blank' className={styles.cbannerMedio} id="banner-intermedio">
			{cardWide ? <img src={srcHorizontal} alt={alt} className={styles.bannerMedioWide} data-apartado="banner_lista_seo_intermedio" data-nombre-campana="nombre_campaña_intermedio"/> :
				<img src={srcDefault} alt={alt}  className={styles.bannerMedio} data-apartado="banner_lista_seo_intermedio" data-nombre-campana="nombre_campaña_intermedio"/>
			}
		</a>
	)
}